<template>
	<section class="event-module mauto">


    <input v-if="isAdmin"
           id="change-main-img"
           @change="change_main_img"
           type="file">


    <article>
      <img class="w100 pointer"
           :src="require('../assets/events/' + event.name + '/0.jpg')"
           @click="galleryInit(0)"
           alt="event main img">

      <div>
        <article class="article-text">
          <p class="mtop0">{{ event.textPreview }}
            <span class="pointer" @click="read_more(event)">citește mai mult</span>
          </p>
          <p class="distribution">{{ event.distribution }}</p>
        </article>

        <ul v-if="!event.noPics"
            class="gallery flex flex-between">
          <li v-for="(item, key) in 4"
              :key="key">
            <img class="w100 pointer"
                 @click="galleryInit(item)"
                 :src="require('../assets/events/' + event.name + '/' + item +'.jpg')" alt="img gallery">
          </li>
        </ul>
      </div>
    </article>
	</section>
</template>

<script>
	export default {
		name: 'event-module',
    props: {
      event: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        gallery: undefined,
        index: 0
      }
    },
    computed: {
      isAdmin () {
        return this.$store.state.isAdmin
      }
    },
    methods: {
      galleryInit (index) {
        this.$store.dispatch('init_photoswipe', {event: this.event, index})
      },
      change_main_img (e) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.append('file', file)
        formData.append('id', this.event.id)
        const clbk = name => {
          this.mainImgName = name
          this.isMainImg = true
        }
        this.$store.dispatch('change_event_main_img', {formData, clbk})
        this.isMainImg = false
      },
      read_more (event) {
        const modalData = {
          title: event.title,
          content: event.fullText
        }
        this.$store.commit('SET_STATE_KEY', {name: 'isModal', val: true})
        this.$store.commit('SET_STATE_KEY', {name: 'modalData', val: modalData})
      }
    }
	}
</script>

<style lang="less">
  @import "../styles/var";
	.event-module {
    border: 1px solid lightgrey;
    padding: 12px;
    width: 90%;
    .gallery {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 48%;
      }
    }
    .article-text {
      font-size: 1.8rem;
      p:first-child {
        font-size: 2rem;
        span {
          color: green;
          font-weight: bold;
        }
      }
      .distribution {
        font-size: 1.7rem;
      }
    }

    @media only screen and (max-width: 1024px) {
      max-width: 500px;
    }

    @media only screen and (min-width: 1024px) {
      max-width: 840px;
      & > article {
        display: flex;
        justify-content: space-between;
        & > img {
          width: 49%;
          align-self: center
        }
        div {
          width: 49%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
      }
    }
	}
</style>
